import { axios, fileAxios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluacionesAntecedentes: [],
    evaluacionesAntecedentesExpediente: [],
  },

  getters: {
    getEvaluacionesAntecedentes: (state) => state.evaluacionesAntecedentesExpediente,
  },

  mutations: {
    SET_EVALUACIONES_ANTECEDENTES(state, evaluacionesAntecedentes) {
      state.evaluacionesAntecedentes = evaluacionesAntecedentes;
    },

    SET_EVALUACIONES_ANTECEDENTES_EXPEDIENTE(state, evaluacionesAntecedentesExpediente) {
      state.evaluacionesAntecedentesExpediente = evaluacionesAntecedentesExpediente;
    },
  },

  actions: {
    async fetchEvaluacionesAntecedentes({ commit }) {
      axios
        .get('PoliciaCuadrantes/C3/evaluacionesantecedentes')
        .then((response) => {
          commit('SET_EVALUACIONES_ANTECEDENTES', response.data.data);
        });
    },

    async fetchEvaluacionesAntecedentesByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/evaluacionesantecedentes`)
        .then((response) => {
          commit('SET_EVALUACIONES_ANTECEDENTES_EXPEDIENTE', response.data.data);
        });
    },

    async saveEvaluacionAntecedentes(context, evaluacionAntecedentes) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${evaluacionAntecedentes.fk_idExpediente}/evaluacionesantecedentes`, evaluacionAntecedentes)
        .then((response) => {
          const formData = new FormData();
          formData.append('file', evaluacionAntecedentes.file);
          formData.append('idAntecedentes', response.data.data[0].ID);
          context.dispatch('uploadEvaluacionAntecedentes', formData);
        });
    },

    async updateEvaluacionAntecedentes(_, evaluacionAntecedentes) {
      await axios
        .put(`PoliciaCuadrantes/C3/expedientes/${evaluacionAntecedentes.fk_idExpediente}/evaluacionesantecedentes`, evaluacionAntecedentes);
    },

    async uploadEvaluacionAntecedentes(context, formData) {
      await fileAxios
        .post('/C3/SetAdjuntoAntecedentes/uploadFiles', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Informe de antecedentes guardada correctamente.', {
            root: true,
          });
        });
    },
  },
};
